import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import moment from "moment";
import {
    DialogTitle,
    Dialog,
    DialogContent,
    InputLabel,
    TextField,
    DialogActions,
    FormControl,
    Select,
    MenuItem,
    Grid,
} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    textField: { margin: theme.spacing(1) },
    button: {
        color: "white",
        background: theme.palette.primary.main,
        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
        },
    },
    gridElLeft: {
        [theme.breakpoints.down('xs')]: {
          textAlign: 'center',
        },
        [theme.breakpoints.up('md')]: {
          textAlign: 'left',
        },
      },
      gridElRight: {
        [theme.breakpoints.down('xs')]: {
          textAlign: 'center',
        },
        [theme.breakpoints.up('md')]: {
          textAlign: 'right',
        },
      },
    commentBoxCont: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    commentBox: {
        marginTop: theme.spacing(2),
    },
    dropdown: {
        margin: theme.spacing(1),
    },
    hoursPadding:{
        paddingTop: "19px",
    },
    status: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        marginTop: 10,
    },
}));

const PtoDialog = props => {
    const classes = useStyles();
    const {
        onClose,
        open,
        reqObj,
        handleSubmit,
        dialogObj,
        handleDelete,
        getDialogValues,
    } = props;
    const handleClose = () => onClose();
    const handleChange = e => getDialogValues(e);
    const handleReadOnly = () => dialogObj.requestStatus !== "";
    const formatDate = date => moment(date).format("MM-DD-YYYY");
    const datediff = (date1,date2) =>{
        return moment(date1).diff(moment(date2),'days');
    } 
    const requestTypes = ["vacation", "sick", "holiday","bereavement"];
    const requestTypesObj = {"vacation":"Vacation","sick":"Sick","holiday":"Holiday","bereavement":"Bereavement"};
    const [isValid, setIsValid] = useState(false);
    const [formValues, setFormValues] = useState({
        startDate: "",
        endDate: "",
        type: "",
        partialHours:"",
        managerComments: "",
        userComments: "",
    });
    let getDaysArray = (start, end) => {
        if((start||""=="")||(end||""=="")){
            return 0;
        }
        var dt1 = new Date(moment(start));
        var dt2 = new Date(moment(end));
        var diffTime =(dt2.getTime() - dt1.getTime());
        var daysDiff = diffTime / (1000 * 3600 * 24); 
        return daysDiff;
    };
    const renderButtons = () => {
        const { requestStatus } = dialogObj;
        if (requestStatus === "Pending") {
            return (
                <Button className={classes.button} onClick={handleDelete}>
                    Delete
                </Button>
            );
        }
        if (requestStatus === "Approved" || requestStatus === "Declined") {
            return null;
        }
        return (
            <>
                <Button className={classes.button} onClick={handleClose}>
                    Cancel
                </Button>
                <Button
                    disabled={!isValid}
                    className={classes.button}
                    onClick={handleSubmit}
                >
                    Submit
                </Button>
            </>
        );
    };

    const handleIsValid = () => {
        return reqObj.startDate === "" ||
            reqObj.endDate === "" ||
            reqObj.requestType === ""
            ? setIsValid(false)
            : setIsValid(true);
    };

    useEffect(() => {
        handleIsValid();
    }, [reqObj]);

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            open={open}
            className={classes.root}
        >
            <DialogTitle id="simple-dialog-title">
                {dialogObj.requestTitle}
            </DialogTitle>
            <DialogContent className={classes.content}>
                <form autoComplete="off">
                    <div style={{ margin: 0, padding: 0 }}>
                        <div>
                            <TextField
                                className={classes.textField}
                                readOnly={handleReadOnly()}
                                fullWidth
                                name="startDate"
                                label="Start Date"
                                value={
                                    Object.keys(dialogObj).length
                                        ? dialogObj.start || ""
                                        : formatDate(reqObj.startDate)
                                }
                            />
                            <TextField
                                className={classes.textField}
                                readOnly={handleReadOnly()}
                                fullWidth
                                label="End Date"
                                value={
                                    Object.keys(dialogObj).length
                                        ? formatDate(dialogObj.end) || ""
                                        : formatDate(reqObj.endDate)
                                }
                            />
                        </div>
                        <Grid container justify='center' alignItems='center' >
                        <Grid item xs={12} md={8} className={classes.gridElLeft}>
                           <FormControl
                           fullWidth
                              variant='standard' className={classes.dropdown}
                              readOnly={handleReadOnly()}>
                              <InputLabel id="select-label-title">
                                  Type
                              </InputLabel>
                              <Select 
                                  labelId="select-label-requestType"
                                  name="requestType"
                                  onChange={handleChange}
                                  value={Object.keys(dialogObj).length ? dialogObj.requestType || "" : reqObj.requestType}
                                  id="requestType"
                                  required={true}
                              >
                                  {requestTypes.map(type => {
                                      return (
                                          <MenuItem value={type}>{requestTypesObj[type]}</MenuItem>
                                      );
                                  })}
                              </Select>
                              </FormControl>
                              </Grid>
                              {(dialogObj.requestType || "")==""}
                              <Grid item xs={12} md={1} >
                                </Grid>
                              <Grid item xs={12} md={3} className={classes.gridElRight}>
                              <FormControl
                              fullWidth
                              disabled={(Object.keys(dialogObj).length ? dialogObj.requestType || "" : reqObj.requestType)=="holiday"}
                              readOnly={handleReadOnly()}>
                              <TextField 
                             disabled={(Object.keys(dialogObj).length ? dialogObj.requestType || "" : reqObj.requestType)=="holiday"}
                              className={classes.hoursPadding} 
                              type="number"
                              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                  placeholder="partial hours"
                                  onChange={(e)=>{
                                    const value = e.target.value||0;
                                    if(!isNaN(Number(value)) && Number(value)<=7 && Number(value)>=0)
                                    handleChange(e)}}
                                  value={Object.keys(dialogObj).length ? dialogObj.partialHours || "" : reqObj.partialHours}
                                  id="partialHours"
                                  name="partialHours"
                                  required={false}>
                              </TextField>
                              </FormControl>
                              </Grid>
                              </Grid>
                        <div className={classes.commentBoxCont}>
                            {dialogObj.managerComment ? (
                                <TextField
                                     className={classes.commentBox}
                                    id="outlined-basic"
                                    readOnly
                                    label={`Managers Comments`}
                                    autoFocus
                                    variant="outlined"
                                    value={dialogObj.managerComment || ""}
                                />
                            ) : null}
                            <TextField
                                disabled={(datediff(reqObj.startDate)||"",formatDate(reqObj.endDate)||"")>=0}
                                className={classes.commentBox}
                                autoFocus
                                readOnly={handleReadOnly()}
                                id="outlined-basic"
                                label="Comments"
                                name="userComments"
                                variant="outlined"
                                onChange={handleChange}
                                value={
                                    Object.keys(dialogObj).length
                                        ? dialogObj.userComments || ""
                                        : reqObj.userComments
                                }
                            />
                        </div>
                    </div>
                </form>
                {Object.keys(dialogObj).length ? (
                    <div className={classes.status}>
                        <b>Status:</b>
                        <p>{dialogObj.requestStatus}</p>
                    </div>
                ) : null}
            </DialogContent>
            <DialogActions>{renderButtons()}</DialogActions>
        </Dialog>
    );
};

PtoDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};

export default PtoDialog;
